import apis from './services.api';

function confirmAppointmentHasBeenBooked(emailAddress: string): Promise<void> {
  return apis.confirmAppointmentHasBeenBooked(emailAddress);
}

export default {
  confirmAppointmentHasBeenBooked,
};
